import { useT } from "../i18n/index.js";
import { AssetIcon } from "../assets/Icon.js";
import "./navigation.css";
import "../ui/motion.css";

const ITEMS: { to: string; key: string; icon: string; badge?: "chat" | "store" | "events" | "alliance" }[] = [
  { to: "/app", key: "nav.base", icon: "bld.command_nexus" },
  { to: "/app/map", key: "nav.map", icon: "bld.sensor_array" },
  { to: "/app/units", key: "nav.units", icon: "unit.bulwark_titan" },
  { to: "/app/inventory", key: "nav.inventory", icon: "bld.storage_vault" },
  { to: "/app/store", key: "nav.store", icon: "itm.chest_gold", badge: "store" },
  { to: "/app/events", key: "nav.events", icon: "bld.event_plaza", badge: "events" },
  { to: "/app/alliance", key: "nav.alliance", icon: "bld.command_center", badge: "alliance" },
  { to: "/app/chat", key: "nav.chat", icon: "bld.comms_tower", badge: "chat" },
];

/** Production navigation, also rendered with isolated sample counts in the gallery. */
export function Navigation({ route, badges, onNavigate, preview = false }: { route: string; badges: { chat: number; store: number; events: number; alliance: number }; onNavigate: (path: string) => void; preview?: boolean }) {
  const t = useT();
  return <nav className={`glass primary-nav ${preview ? "navigation-preview" : ""}`} aria-label={t("ui.navigation")} data-testid="bottom-nav">
    {ITEMS.map(item => {
      const active = item.to === "/app" ? route === item.to : route.startsWith(item.to);
      const count = item.badge ? badges[item.badge] : 0;
      const max = item.badge === "chat" ? 99 : 9;
      return <a key={item.to} href={item.to} aria-current={active ? "page" : undefined} className={`navigation-item ${active ? "active" : ""}`}
        onClick={event => { if (!preview && (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)) return; event.preventDefault(); onNavigate(item.to); }}>
        <span className="navigation-icon"><AssetIcon id={item.icon} size={48} alt="" />{count > 0 ? <span className={`nav-badge ui-pulse ${item.badge === "store" ? "gold" : ""}`} data-testid={item.badge === "chat" ? "nav-unread" : `nav-${item.badge}-badge`}>{count > max ? `${max}+` : count}</span> : null}</span>
        <span>{t(item.key)}</span>
      </a>;
    })}
  </nav>;
}

